import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponseWithPagination, GetGoalsSchema, GoalsResponseDataSchema } from "schema"
import { z } from "zod"

type Query = z.input<typeof GetGoalsSchema>
type Response = DataResponseWithPagination<z.infer<typeof GoalsResponseDataSchema>>

type Props = {
  companyId: string
  query?: Query
  onSuccess?: (data: Response) => void
  enabled?: boolean
}

const getBackofficeGoalsQueryKey = (companyId: string, query: Query = {}) => [
  "backoffice",
  "goals",
  companyId,
  query,
]

export const backofficeGoalsQuery = ({ companyId, query, onSuccess, enabled = true }: Props) => {
  return queryOptions({
    queryKey: getBackofficeGoalsQueryKey(companyId, query),
    queryFn: async () => {
      const { data } = await axios.get<Response>(`/backoffice/campaigns/${companyId}/goals`, {
        params: query,
      })
      onSuccess?.(data)
      return data.data
    },
    enabled,
  })
}
